import React, { Dispatch, SetStateAction } from "react";
import { AxiosInstance } from "axios";
import { ReceiptInfo } from "src/views/ReceiptsForm/types";
import { RequestStatus } from "../api/types";

export interface PaginationInfo {
  total: number;
  limit: number;
  offset: number;
  hasMore: boolean;
}

export interface IReceiptsContext {
  receipts: ReceiptInfo[] | null;
  receiptsStatus: RequestStatus;
  pagination: PaginationInfo | null;
  setReceipts: Dispatch<SetStateAction<ReceiptInfo[] | null>>;
  setReceiptsStatus: Dispatch<SetStateAction<RequestStatus>>;
  setPagination: Dispatch<SetStateAction<PaginationInfo | null>>;
  searchReceipts: (
    api: AxiosInstance,
    searchParams: Record<string, string>
  ) => Promise<ReceiptInfo[]>;
  loadMoreReceipts: (
    api: AxiosInstance,
    searchParams: Record<string, string>
  ) => Promise<void>;
}

export const defaultReceiptsContext: IReceiptsContext = {
  receipts: null,
  receiptsStatus: "idle",
  pagination: null,
  setReceipts: () => {
    throw new Error("Not Implemented");
  },
  setReceiptsStatus: () => {
    throw new Error("Not Implemented");
  },
  setPagination: () => {
    throw new Error("Not Implemented");
  },
  searchReceipts: async () => {
    throw new Error("Not Implemented");
  },
  loadMoreReceipts: async () => {
    throw new Error("Not Implemented");
  },
};

export const ReceiptsContext = React.createContext<IReceiptsContext>(
  defaultReceiptsContext
);
